import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
const SwatchSelector = lazy(() => import('./SwatchSelectorMain'));

const PdpSharedSwatchSelectorComponent = props => {
    const {
        currency,
        onClick,
        item,
        user,
        relay,
        transactions,
        selectedSkuId,
        showSwatchDescriptionOnHover,
    } = props;
    return (
        <Suspense fallback={''}>
            <SwatchSelector
                currency={currency}
                selectedSkuId={selectedSkuId}
                item={item}
                user={user}
                transactions={transactions}
                onClick={onClick}
                relay={relay}
                pageLayout="PDP"
                showSwatchDescriptionOnHover={showSwatchDescriptionOnHover}
            />
        </Suspense>
    );
};

PdpSharedSwatchSelectorComponent.propTypes = {
    currency: PropTypes.string,
    relay: PropTypes.object.isRequired,
    onSwatchClick: PropTypes.func,
    selectedSkuId: PropTypes.string,
    onClick: PropTypes.func,
    showSwatchDescriptionOnHover: PropTypes.bool,

    // relay response data
    user: PropTypes.object,
    item: PropTypes.object.isRequired,
    transactions: PropTypes.object,
};
export const PdpSharedSwatchSelector = createFragmentContainer(PdpSharedSwatchSelectorComponent, {
    item: graphql`
        fragment PdpSharedSwatchSelector_item on Item {
            ...SwatchSelector_item
        }
    `,
    user: graphql`
        fragment PdpSharedSwatchSelector_user on User {
            ...SwatchSelector_user
        }
    `,
    transactions: graphql`
        fragment PdpSharedSwatchSelector_transactions on TransactionConnection {
            ...SwatchSelector_transactions
        }
    `,
});
